import { DateVariant, SelectedTime } from '@lyearn/ui';
import DatePicker from '@/components/DatePicker';
import { FieldType } from '@/components/Form';
import { DatabaseField } from '@/modules/corporate/modules/database/fields/types';

import DateFieldEditorConfig from './Editor/config';
import adaptFormData from './adaptFormData';
import Cell from './Cell';
import { DateFieldStaticConfig } from './config';
import EditableCell from './EditableCell';
import FilterInput from './FilterInput';
import CheckBoxOperators from './operators';
import parseFormData from './parseFormData';
import { isFormDataValid } from './utils';

const DateField: DatabaseField = {
  ...DateFieldStaticConfig,
  Table: {
    Cell,
    EditableCell,
    FilterInput,
    operators: CheckBoxOperators,
  },
  Viewer: {
    adaptFormData,
    parseFormData,
    fieldType: FieldType.Custom,
    isFormDataValid,
    adaptFormField: DateFieldEditorConfig.adaptEditorFormField,
  },
  Editor: DateFieldEditorConfig,
  Component: ({ value, onChange, field, error, touched }) => (
    <DatePicker
      error={error && touched ? error : ''}
      input={{
        placeholder: field?.placeholder,
      }}
      pickerProps={{
        variant: field?.rendererProps.variant || DateVariant.Date,
        selectedTime: value?.startTime,
        onChange: (selectedTime?: SelectedTime) => {
          onChange({ startTime: selectedTime || null });
        },
      }}
    />
  ),
};

export default DateField;
